import axios from "axios";
import router from "./router";
import Element from "element-ui";
import JSON_BIG from 'json-bigint'

// axios.defaults.baseURL = "http://localhost:9091"		//本地开发环境
axios.defaults.baseURL = "/api"		//测试和生产环境：使用相对路径，通过Nginx反向代理
//axios.defaults.baseURL = "https://api-manage.showme.cc/"   //备用配置
//axios.defaults.baseURL = "http://39.108.96.20:8081"		//正式环境（已废弃，使用Nginx代理）

const request = axios.create({
	timeout: 5000,
	headers: {
		'Content-Type': "application/json; charset=utf-8"
	},
	transformResponse: data => {
		try{
			// 使用json-bigint处理Long类型，storeAsString: true将Long转为字符串避免精度丢失
			return JSON_BIG({ storeAsString: true }).parse(data);
		}catch (err) {
			console.log(err);
			return JSON.parse(data)
		}
	}
})

request.interceptors.request.use(config => {
	// 对于验证码接口，不添加Authorization头
	if (config.url !== '/captcha') {
		config.headers['Authorization'] = localStorage.getItem("token")
	}
	return config
})

request.interceptors.response.use(
	response => {

		console.log("response ->" + response)

		let res = response.data

		if (res.code === 200) {
			return response
		} else {
			const errorMsg = res.msg || '系统异常'
			Element.Message.error(errorMsg)
			return Promise.reject(new Error(errorMsg))
		}
	},
	error => {

		console.log(error)

		let errorMessage = '系统异常'

		// 防止空指针异常：检查error.response是否存在
		if (error.response) {
			// 优先使用后端返回的错误信息
			if (error.response.data && error.response.data.msg) {
				errorMessage = error.response.data.msg
			} else if (error.response.data && error.response.data.message) {
				errorMessage = error.response.data.message
			} else {
				// 根据HTTP状态码提供友好的错误提示
				switch (error.response.status) {
					case 401:
						errorMessage = '登录已过期，请重新登录'
						router.push("/login")
						break
					case 403:
						errorMessage = '权限不足，您没有执行此操作的权限。请联系系统管理员分配相应权限。'
						break
					case 404:
						errorMessage = '请求的资源不存在'
						break
					case 500:
						errorMessage = '服务器内部错误，请稍后重试'
						break
					default:
						errorMessage = `请求失败（${error.response.status}）`
				}
			}

			// 401状态码需要跳转到登录页
			if (error.response.status === 401) {
				router.push("/login")
			}
		} else {
			// 网络错误或连接被拒绝
			if (error.code === 'ECONNREFUSED' || error.message === 'Network Error') {
				errorMessage = '无法连接到服务器，请检查后端服务是否运行'
			} else {
				errorMessage = error.message || '网络错误'
			}
		}

		Element.Message.error(errorMessage, {duration: 5000})
		return Promise.reject(new Error(errorMessage))
	}
)

export default request
